import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntityToCfHomePage } from './mapper';

/**
 * CfHomePage
 * This function returns an anonymous class which will can used for mapping homepage content.
 * @param {boolean} loggedIn
 * @export
 * @class CfHomePage
 */
export const CfHomePage = (loggedIn = false) =>
    class {
        static pageName = 'homePage';

        static mapCfEntry = mapCfEntityToCfHomePage;

        static get config() {
            return {
                contentType: contentTypes.CfHomePage,
                filters: {
                    'fields.logged': loggedIn,
                },
            };
        }

        constructor(props = {}) {
            const {
                campaignBanner,
                campaignBannerCarousel,
                name,
                storeCode,
                logged,
                mc2,
                mc3,
            } = props;
            this.data = {
                campaignBanner,
                campaignBannerCarousel,
                name,
                storeCode,
                logged,
                marketingCard2: mc2 || {},
                marketingCard3: mc3 || {},
            };
        }
    };
